export const keys = {
  all: ['fieldMappings'] as const,
  lists: () => [...keys.all, 'list'] as const,
  list: (projectId: number) => [...keys.lists(), projectId] as const,
  sourceFields: (projectId: number) =>
    [...keys.all, 'sourceFields', projectId] as const,
};
